import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-terms-and-conditions',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './terms-and-conditions.component.html'
})
export class TermsAndConditionsComponent {}
